export const clubsQueryKeys = {
	clubs: {
		all: ["clubs"] as const,
		detail: (id: string) => ["clubs", id] as const,
		friends: (params?: Record<string, unknown>) => ["clubs", "friends", params ?? {}] as const,
		indexStats: ["clubs", "index-stats"] as const,
		members: (clubId: string) => ["clubs", clubId, "members"] as const,
		membersList: (params?: object) => ["clubs", "members", params ?? {}] as const,
	},
	clubTournaments: {
		all: ["club-tournaments"] as const,
		detail: (id: string) => ["club-tournaments", id] as const,
		list: (filter?: Record<string, unknown>) => ["club-tournaments", "list", filter ?? {}] as const,
	},
	explore: {
		clubs: (params?: Record<string, unknown>) => ["explore", "clubs", params ?? {}] as const,
	},
	leagues: {
		all: ["leagues"] as const,
		detail: (id: string) => ["leagues", id] as const,
		entries: (id: string, seasonId?: string) =>
			["leagues", id, "entries", seasonId ?? "current"] as const,
		list: (clubId: string, status?: string) =>
			["leagues", "club", clubId, status ?? "active"] as const,
		match: (leagueId: string, matchId: string) =>
			["leagues", leagueId, "matches", matchId] as const,
		matches: (leagueId: string, filters?: Record<string, unknown>) =>
			["leagues", leagueId, "matches", filters ?? {}] as const,
		revisions: (leagueId: string, matchId: string) =>
			["leagues", leagueId, "matches", matchId, "revisions"] as const,
		seasons: (leagueId: string) => ["leagues", leagueId, "seasons"] as const,
	},
	sites: {
		all: ["academy-sites"] as const,
		list: (status?: string) => ["academy-sites", "list", status ?? "all"] as const,
	},
} as const;
